module.exports = __webpack_public_path__ + "InterstateWGL-Italic.fea690b4aa75e894d78d.woff";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/InterstateWGL-Italic.woff
// module id = ../../../../../src/assets/layout/fonts/InterstateWGL-Italic.woff
// module chunks = styles